import React from "react"

// Views
import AppPanel from "@views/AppPanel"

// Components
import Headline from "@components/Headline"
import Link from "@components/Link"
import Metatags from "@components/Metatags"

// Material UI
import Avatar from "@material-ui/core/Avatar"
import AvatarGroup from "@material-ui/lab/AvatarGroup"
import Tooltip from "@material-ui/core/Tooltip"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@components/Typography"
import Container from "@material-ui/core/Container"
import { classicNameResolver } from "typescript"

const useStyles = makeStyles((theme) => ({
    group: {
        display: "flex",
        justifyContent: "center",
    },
    large: {
        width: theme.spacing(15),
        height: theme.spacing(15),
    },
    text: {
        marginTop: theme.spacing(6),
    },
}))

function Team(props) {
    const styles = useStyles()
    const team = [
        {
            name: "lukasz",
            role: "founder",
            photoURL:
                "https://lh3.googleusercontent.com/a-/AOh14Gh_uupZ32xKXC-33zvuk3-kS1j8i0dkDVLaTh7-8Jg=s96-c",
            linkedin: "https://www.linkedin.com/in/szczesiaklukasz/",
        },
    ]

    return (
        <AppPanel>
            <Metatags subtitle="team" path="team" />
            <Headline>SKIP/Team</Headline>
            <AvatarGroup spacing="small" className={styles.group}>
                {team.map((user) => (
                    <Tooltip
                        key={user.name}
                        title={`Visit LinkedIn Profile`}
                        arrow
                        placement="bottom"
                    >
                        <Avatar
                            component={Link}
                            href={user.linkedin}
                            className={styles.large}
                            src={user.photoURL || "https://"}
                            alt={user.name}
                        ></Avatar>
                    </Tooltip>
                ))}
            </AvatarGroup>
            <Container maxWidth="xs" className={styles.text}>
                <Typography variant="h6" align="center">
                    {`lukasz / founder`}
                </Typography>
                <Typography align="center">
                    I’m on a mission to make content more relevant, personalised and
                    ultimately more valuable to all of us. By trade I’m a software
                    engineer, by calling a mentor, by choice a founder, and by mistake an
                    amateur stand-up comedian **ba dum tss**
                </Typography>
            </Container>
        </AppPanel>
    )
}

export default Team
